import type { Pead } from "epsm-api-types/models";
import { formatValuePercent } from "@/components/widgets/helpers/FormattingHelpers";
import { DriftPoint } from "../../../types";

type Args = {
	data: Pead;
	quarters?: string;
	driftEnd?: boolean;
};

export function getAccuracyDriftForHistory(args: Args): string {
	const { data, quarters = DriftPoint.QTR_END, driftEnd = true } = args;
	const accuracy = data.accuracy || [];

	if (!accuracy?.length) return "Pending";

	const qtrEndAcc = accuracy.find(
		(a) => a.drift_point === quarters && a.depends_on_type === driftEnd,
	);

	return formatValuePercent(qtrEndAcc!.value, "0%");
}
